import { render } from "./Loader.vue?vue&type=template&id=1898edbd&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=1898edbd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1898edbd"]])

export default __exports__